import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { AppService, CoreTypes } from 'common-cloudstudio';
import { ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';
import { ApolusService } from '../../services/apolus.service';

@Component({
  selector: 'app-status-summary',
  templateUrl: './status-summary.component.html',
  styleUrls: ['./status-summary.component.scss'],
})
export class StatusSummaryComponent implements OnChanges {
  @Input() data: ApolusTypes.DashboardDeviceSummary;
  @Input() allowClick: boolean = false;
  @Input() displayTopTitle: boolean = false;
	@Output() onClick:EventEmitter<Event>= new EventEmitter<Event>();
  summary: ApolusTypes.DashboardDeviceSummary;
  
  constructor(
    private _renderer: Renderer2, 
    private _el: ElementRef,
    public appService: AppService,
    public _apolusService: ApolusService,
  ) {
    this._renderer.addClass(this._el.nativeElement, 'hvr-wobble-horizontal');
  }

  ngOnChanges(): void {
    if (this.data) {
      this.summary = this.data;
    }
  }

	_onClick($event:Event){
		this.onClick.emit($event);
	}

  rgbToHexa(rgb: any) {
    if (!rgb) return '#000000';
    let value = '000000' + rgb?.toString(16);
    value = value.substring(value.length - 6);
    value = '#' + value;
    return value;
  }

  getPercentage(value: number, total: number): number {
    if (!total || total === 0) return 0;
    return Math.round((value / total) * 100);
  }
  
}
